// extracted by mini-css-extract-plugin
module.exports = {"title":"reports_title__1ZmBO","report":"reports_report__39mI4","name":"reports_name__2WCKA","fileIcon":"reports_fileIcon__3pxty","viewMore":"reports_viewMore__iRFp3"};